/**
 * Sidebar brand: full wordmark across the open rail, pillow mark in the
 * same size-8 slot as the nav icons when the rail collapses.
 */
import X9Logo from '../../execute/components/X9Logo';

type Props = {
  href: string;
};

export default function SidebarWordmark({ href }: Props) {
  return (
    <a
      href={href}
      aria-label="X9"
      className="flex w-full items-center px-2 text-sidebar-foreground group-data-[collapsible=icon]:size-8 group-data-[collapsible=icon]:w-8 group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:p-2"
    >
      <X9Logo
        variant="wordmark"
        title="X9"
        className="h-[60px] w-auto group-data-[collapsible=icon]:hidden"
      />
      <X9Logo variant="mark" className="hidden h-5 w-auto group-data-[collapsible=icon]:block" />
    </a>
  );
}
